import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import DioceseAddChild from "./DioceseAddChild";

const DioceseAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <DioceseAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default DioceseAdd;
